// preview-render-cache.ts — the interactive renderPreview() dedup cache.
//
// (Modernization Tier 5: extracted from markdown-renderer.ts to break the
// markdown-renderer ↔ table-features import cycle.)
//
// renderPreview() skips re-parsing when the (file, content) pair is unchanged
// and the #preview DOM is still intact. Holding the cache in this neutral leaf
// gives both markdown-renderer and table-features a one-way edge into it
// (neither is imported by this module), breaking the cycle.

/** The last fully-rendered (file, content) pair and its HTML. */
export const renderCache: { file: any; content: any; html: any } = {
  file: null,
  content: null,
  html: null,
};

/** Drop the whole cache so the next renderPreview() rebuilds the DOM from scratch. */
export function resetRenderCache(): void {
  renderCache.file = null;
  renderCache.content = null;
  renderCache.html = null;
}
